import { EnumHashParameterStore } from 'blocks/hash_parameter';

export enum EditorMode {
  Sitemap = 'sitemap',
  Wireframe = 'wireframe',
  Styleguide = 'styleguide',
  Design = 'design',
}

const EDITOR_MODES = [
  EditorMode.Sitemap,
  EditorMode.Wireframe,
  EditorMode.Styleguide,
  EditorMode.Design,
] as const;

export const editorModeStore = new EnumHashParameterStore<EditorMode>(
  'mode',
  EDITOR_MODES,
  EditorMode.Sitemap,
);

export const isWireframeOrDesign = (mode: EditorMode) =>
  mode === EditorMode.Wireframe || mode === EditorMode.Design;
